import React, { useRef, useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

import Header from "./Header";
import AlertBox from "./AlertBox";

import "../css/auth.css";
import { Link, useNavigate } from "react-router-dom";

function Signin() {
    const [isLoading, setLoading] = useState(false);

    const emailRef = useRef();
    const passRef = useRef();
    const { signin, currentUser } = useAuth();

    const redirect = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setLoading(true);
            await signin(emailRef.current.value, passRef.current.value);
            redirect("/profile");
        }
        catch {
            document.getElementById("alertbox").classList.add("showAlert");
        }
        setLoading(false);
    }
    useEffect(() => {
        if (currentUser) {
            return redirect("/profile");
        }
    })

    return (
        <>
            <Header/>
            <form action="POST" className="auth">
                <div className="auth__container">
                    <div className="auth__general">
                        <img src={process.env.PUBLIC_URL + "/img/logo/NedoLib-1024x1024.webp"} alt="Logo" width="96" height="96"/>
                        <h1>Welcome, back</h1>
                        <p>YEAHHHH, commenting is coming</p>
                    </div>
                    <div id="sign-in" className="auth__inputs">
                        <div className="inputs">
                            <input className="inputs__input" id="email" type="text" autoComplete="off" ref={emailRef} required/>
                            <span className="inputs__text">Email</span>
                        </div>
                        <div className="inputs">
                            <input className="inputs__input" id="pass" type="password" autoComplete="off" ref={passRef} required/>
                            <span className="inputs__text">Password</span>
                        </div>
                    </div>
                    <div className="auth__additional-buttons">
                        <Link to="/forgot-password" className="additional-buttons__forgot_text">Forgot Password</Link>
                        <button className="additional-buttons__submitbtn" disabled={isLoading} onClick={handleSubmit}>Sign In</button>
                        <Link to="/sign-up">Don't have an account?</Link>
                    </div>
                </div>
            </form>
            
            {AlertBox("Error", "Email/Password are incorrect")}
        </>
    )
}

export default Signin;